// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_is","advertCardFooter__row":"c-a_it","advertCardFooter__name":"c-a_iu","advertCardFooter__price":"c-a_iv","advertCardFooter__age":"c-a_iw"};